// Eskom PARCC — 404 / unknown-route screen.
//
// Replaces the old catch-all silent redirect to /dashboard: a mistyped or stale
// URL now lands on a small branded card that says so and offers a way back,
// rather than quietly swallowing the path.
import { Link } from 'react-router-dom';

export function NotFoundPage(): React.JSX.Element {
  return (
    <section className="card">
      <h3>Page not found</h3>
      <p className="small">That page doesn’t exist.</p>
      <Link to="/dashboard" className="btn primary">
        Back to Dashboard
      </Link>
    </section>
  );
}
